import { Component, HostListener } from '@angular/core';
import { SidebarService } from './sidebar.service';
import { ApiService } from '../services/api.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { version, versionDate } from '../../environments/version';
import {
  faHome,
  faUsers,
  faClipboardList,
  faUser,
  faArchive,
  faChartBar,
  faFileExport,
} from '@fortawesome/free-solid-svg-icons';
import { ServicioAutenticacion } from '../auth/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
})
export class Navbar {
  editableMenuPermissions = { ...ServicioAutenticacion.MENU_PERMISSIONS };

  private visibleSubmenus: { [key: string]: boolean } = {};
  meses: number = 3;
  fechaDesde!: string;
  fechaHasta!: string;


  appVersion: string = version;
  appDateVersion: string = versionDate;
  apiVersion: string = '';
  dbVersion: string = '';
  apiDateVersion: string = '';
  dbDateVersion: string = '';
  ngOnInit(): void {
    this.apiSrv.obtenerVersionApiYDb().subscribe((data) => {
      this.apiVersion = data.apiVersion;
      this.apiDateVersion = data.apiDateVersion;
      this.dbVersion = data.dbVersion;
      this.dbDateVersion = data.dbDateVersion;
    });
    const hoy = new Date();
    const haceUnMes = new Date();
    haceUnMes.setMonth(haceUnMes.getMonth() - 1);

     // Formatear las fechas a YYYY-MM-DD
    this.fechaDesde = haceUnMes.toISOString().split('T')[0];
    this.fechaHasta = hoy.toISOString().split('T')[0];
  }

  constructor(
    public sidebarSrv: SidebarService,
    public apiSrv: ApiService,
    private library: FaIconLibrary
  ) {
    this.actualizarEstadoSidebar();
    this.library.addIcons(
      faHome,
      faUsers,
      faClipboardList,
      faUser,
      faArchive,
      faChartBar,
      faFileExport
    );
    this.loadSubmenuState();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.actualizarEstadoSidebar();
  }

  hasPermission(menuCategory: string): boolean {
    const rolesPermitidos =
      ServicioAutenticacion.MENU_PERMISSIONS[menuCategory] || [];
    return rolesPermitidos.some((role) => this.sidebarSrv.hasRole(role));
  }

  actualizarEstadoSidebar() {
    const isSmallScreen = window.innerWidth <= 768;
    this.sidebarSrv.establecerEstadoBarraLateral(isSmallScreen);
  }

  get isSidebarCollapsed() {
    return this.sidebarSrv.obtenerEstadoBarraLateral();
  }

  toggleSubmenu(submenu: string) {
    this.visibleSubmenus[submenu] = !this.visibleSubmenus[submenu];
    this.saveSubmenuState();
  }

  isSubmenuVisible(submenu: string): boolean {
    return this.visibleSubmenus[submenu];
  }

  saveSubmenuState() {
    localStorage.setItem('submenuState', JSON.stringify(this.visibleSubmenus));
  }

  loadSubmenuState() {
    const defaultState = {
      personasSubmenu: true,
      planesSubmenu: true,
      usuariosSubmenu: true,
      archivosSubmenu: true,
      reporteSubmenu: true,
      gestosSubmenu: true,
    };

    const savedState = localStorage.getItem('submenuState');
    this.visibleSubmenus = savedState ? JSON.parse(savedState) : defaultState;
  }

  abrirVentana(nombreVentana: string) {
    this.sidebarSrv.cambiarEstadoDeVentana(nombreVentana, true);
  }

  cerrarVentana(nombreVentana: string) {
    this.sidebarSrv.cambiarEstadoDeVentana(nombreVentana, false);
  }

  getEstadoVentana(nombreVentana: string): boolean {
    return this.sidebarSrv.obtenerEstadoDeVentana(nombreVentana);
  }

  generarReporteTitularesSinDj() {
    this.apiSrv.obtenerReporteTitularesSinDj().subscribe(
      (data: Blob) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Reporte_TitularesSinDJ.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        // Cierra la ventana después de generar el reporte
        this.cerrarVentana('reporteTitularesSinDj');
      },
      (error) => {
        console.error('Error al generar el reporte:', error);
      },
      () => {
        this.sidebarSrv.cambiarEstadoDeVentana('reporteTitularesSinDj', false);
      }
    );
  }

  exportarArchivosCompletos() {
    this.apiSrv.exportarArchivosCompletos().subscribe(
      (data: Blob) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'GESTOS_PADRON_COMPLETO.txt';
        a.click();
        window.URL.revokeObjectURL(url);
        // Cierra la ventana después de exportar
        this.cerrarVentana('exportarArchivosCompletos');
      },
      (error) => {
        console.error('Error al exportar archivos completos:', error);
      },
      () => {
        this.sidebarSrv.cambiarEstadoDeVentana('exportarArchivosCompletos', false);
      }
    );
  }

  exportarArchivos(tipoArchivo: string, fechaDesde: string, fechaHasta: string) {
    this.apiSrv.exportarArchivos(tipoArchivo, fechaDesde, fechaHasta).subscribe(
      (data: Blob) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.href = url;
        a.download = `GESTOS_${tipoArchivo.toUpperCase()}_DESDE_${fechaDesde}_HASTA_${fechaHasta}.txt`;
        a.click();
        window.URL.revokeObjectURL(url);
        // Cierra la ventana después de exportar
        switch (tipoArchivo) {
          case 'altas':
            this.cerrarVentana('exportarArchivosAltas');
            break;
          default:
            console.error('Tipo de archivo no válido:', tipoArchivo);
        }

      },
      (error) => {
        console.error('Error al exportar archivos:', error);
      },
      () => {
        this.sidebarSrv.cambiarEstadoDeVentana('exportarArchivos', false);
      }
    );
  }
}
